import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyInput = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python User Input</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In this Python tutorial, we will learn how to accept user
                    input in Python. Python has a rich set of built-in
                    functions, in this tutorial we will discuss one of them,
                    input() function for input operation
                  </p>
                </div>
                <h1 className="py_h1">Python Input Function</h1>

                <p>
                  Python 3 has a built-in function input(), to accept keyboard
                  input. The input() method reads a line from the console and
                  converts it into a string. The input() method takes a single
                  optional parameter.
                </p>

                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>
                    username = <span className="python-function"> input </span>
                    ("Enter username:")
                  </p>

                  <p>
                    <span className="python-function">print</span>({" "}
                    <span className="python-string">"Username is: " </span> +
                    username)
                  </p>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: The following example asks for the username, and when
                    you entered the username, it gets printed on the screen:
                    <br />
                    Python 3.6 uses the input() method. <br /> Python 2.7 uses
                    the raw_input() method.
                    <br />
                    <br />
                    Python stops executing when it comes to the input()
                    function, and continues when the user has given some input.
                  </p>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Keyboard Input in Python</h1>
                <hr style={{ color: "white" }} />
                <div>
                  <p>Accept a Text (String) Input in Python</p>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>
                    name = <span className="python-function"> input </span>
                    ("Enter Your Name:")
                  </p>

                  <p>
                    <span className="python-function">print</span>(name)
                  </p>
                </div>
                <p> Accept an Integer Input in Python</p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>
                    a= <span className="python-function">int</span>(
                    <span className="python-function"> input </span>({" "}
                    <span className="python-string">"Enter First Number:"</span>
                    ))
                  </p>
                  <p>
                    b= <span className="python-function">int</span>(
                    <span className="python-function"> input </span>({" "}
                    <span className="python-string">
                      "Enter Second Number:"
                    </span>
                    ))
                  </p>
                  <p>c=a+b</p>
                  <p>
                    <span className="python-function">print</span>(c)
                  </p>
                </div>
                <div className="bg-primary">
                  <p>
                    Note – The int() function in Python, converts the given
                    value in Integer. In the above example input() accept the
                    value as a string, after that int() method converts the
                    input in integer, so we can perform the mathematical
                    operation.
                  </p>
                </div>

                <p>Accept a Float Input in Python</p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>
                    {" "}
                    a= <span className="python-function">float</span>(
                    <span className="python-function"> input </span>({" "}
                    <span className="python-string">"Enter First Number:"</span>
                    ))
                  </p>
                  <p>
                    {" "}
                    b= <span className="python-function">float</span>(
                    <span className="python-function"> input </span>({" "}
                    <span className="python-string">
                      "Enter Second Number:"
                    </span>
                    ))
                  </p>
                  <p>c=a+b</p>

                  <p>
                    <span className="python-function">print</span>(c)
                  </p>
                </div>
                <div className="bg-primary">
                  <p>
                    Note – The float() function in Python used to convert the
                    string in floating number. The function accepts a string
                    value as an argument and returns float.
                  </p>
                </div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
